module.exports = __webpack_public_path__ + "img/registre_elevage.076a2e06.png";